// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { ValidatorResult } from "../ui/types/Types";
import { LINKS_NUMBER_BY_NEWS_THEME } from "../utils/Constant";

export const validate = (values: {
  [key: string]: string | undefined;
}): ValidatorResult => {
  const result: ValidatorResult = {
    validate: true,
    message: ""
  };
  if (values?.color === undefined) {
    result.validate = false;
    result.message = "news_theme.submit.error.color";
    return result;
  }
  if (!!values?.contactMail && !values?.contactLabel) {
    result.validate = false;
    result.message = "news_theme.submit.error.contactLabel";
    return result;
  }
  if (!!values?.contactLabel && !values?.contactMail) {
    result.validate = false;
    result.message = "news_theme.submit.error.contactMail";
    return result;
  }
  for (let i = 0; i < LINKS_NUMBER_BY_NEWS_THEME; i++) {
    const title = values[`link${i}Title`];
    const url = values[`link${i}Url`];
    if (!!title && !url) {
      result.validate = false;
      result.message = "news_theme.submit.error.linkUrl";
      return result;
    }
    if (!!url && !title) {
      result.validate = false;
      result.message = "news_theme.submit.error.linkTitle";
      return result;
    }
  }
  return result;
};
